const animaticRemastered = {
  slug: "animatic-remastered",
  title: "Animatic Remastered",
  category: "Academic Project",
  client: "Algonquin College",
  duration: "1 Week",
  cover: "/assets/animatic-cover.png",
  summary: "A remaster of a Twin Peaks–inspired motion graphics short from Algonquin College, relit and retextured.",
  gallery: [],
  blocks: [
    {
      type: "youtube",
      id: "fSDhwuEcBgQ",
      title: "Youtube Video",
    },
    {
      type: "richText",
      html: "<p><strong>A remaster of a short motion-graphics project created at Algonquin College, with updated lighting and textures. The piece is heavily inspired by Twin Peaks. Watch in 1080p for the intended detail.</strong></p>",
    },
  ],
  relatedSlugs: ["trendless", "seven-due-dates", "2024-chasing-greatness"],
  seo: {
    title: "Animatic Remastered — Matia Dosen",
    description: "UX Designer and Creative",
  },
}

export default animaticRemastered
